/* global swal:false */
(function () {
  "use strict";

  angular
    .module("admin.communities.posts", ["admin.communities.posts.service"])
    .controller("CommunitiesPostsCtrl", CommunitiesPostsCtrl);

  /** @ngInject */
  function CommunitiesPostsCtrl(
    $stateParams,
    $state,
    CommunitiesPostsService,
    PostsAdminService,
    UsersService
  ) {
    var vm = this;
    vm.itemsUnpublished = [];
    vm.itemsPublished = [];
    vm.userId = $stateParams.parentId;

    UsersService.get(vm.userId).then(function (result) {
      vm.user = result.results;
    });

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.usersPerPage = 25;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    function reloadPagination2() {
      vm.totalUsers2 = 0;
      vm.oldPage2 = 0;
      vm.usersPerPage2 = 25;
      vm.currentPage2 = 25;
      vm.first2 = true;
      vm.totalItems2 = 0;
      vm.pagination2 = {
        current: 1,
      };
    }

    var tab = localStorage.getItem("tab_communities_posts");
    if (tab !== null) {
      if (tab === "draft") {
        $("#published").removeClass("active");
        $("#draft").addClass("active");
        $("#drafttab").addClass("active");
      } else if (tab === "published") {
        $("#draft").removeClass("active");
        $("#published").addClass("active");
        $("#publishedtab").addClass("active");
      }
    } else {
      $("#published").addClass("active");
      $("#publishedtab").addClass("active");
    }

    reloadPagination();
    reloadPagination2();

    loadUnpublished(1);
    loadPublished(1);

    function loadUnpublished(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }
      CommunitiesPostsService.listPostsUnpublished(
        vm.userId,
        vm.oldPage,
        25
      ).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          switch (result.results[i].k) {
            case 0:
              result.results[i].type = "Unknown";
              break;
            case 1:
              result.results[i].type = "Channel Post";
              break;
            case 2:
              result.results[i].type = "User Post";
              break;
            case 3:
              result.results[i].type = "Admin Post";
              break;
            case 4:
              result.results[i].type = "Feature Post";
              break;
            case 5:
              result.results[i].type = "Community Post";
              break;
          }
        }

        vm.itemsUnpublished = result.results;
      });
    }

    function loadPublished(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination2.current = 1;
      }
      if (!vm.first2) {
        vm.currentPage2 = pageNumber * 25;
        vm.oldPage2 = vm.currentPage2 - 25;
      } else {
        vm.first2 = false;
      }
      CommunitiesPostsService.listPostsPublished(
        vm.userId,
        vm.oldPage,
        25
      ).then(function (result) {
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          switch (result.results[i].k) {
            case 0:
              result.results[i].type = "Unknown";
              break;
            case 1:
              result.results[i].type = "Channel Post";
              break;
            case 2:
              result.results[i].type = "User Post";
              break;
            case 3:
              result.results[i].type = "Admin Post";
              break;
            case 4:
              result.results[i].type = "Feature Post";
              break;
            case 5:
              result.results[i].type = "Community Post";
              break;
          }
        }

        vm.itemsPublished = result.results;
      });
    }

    vm.pageChanged = function (newPage) {
      load(newPage);
    };

    vm.pageChanged2 = function (newPage) {
      load(newPage);
    };

    vm.tabDraft = function () {
      $("#published").removeClass("active");
      $("#draft").addClass("active");
      localStorage.setItem("tabadmin", "draft");
    };

    vm.tabPublished = function () {
      $("#draft").removeClass("active");
      $("#published").addClass("active");
      localStorage.setItem("tabadmin", "published");
    };

    vm.showDescription = function (item) {
      $("#myModal").modal("show");
      $("#myModal").on("shown.bs.modal", function () {
        $("#description").text(item);
      });
    };

    vm.publish = function (item) {
      PostsAdminService.publish(item.id).then(function () {
        $state.reload();
      });
    };

    vm.unpublish = function (item) {
      PostsAdminService.unpublish(item.id).then(function () {
        $state.reload();
      });
    };

    vm.edit = function (item) {
      $state.go("admin.posts.edit", {
        id: item.id,
        returnUrl: "/admin/communities/" + vm.userId + "/posts",
      });
    };

    vm.comments = function (item) {
      $state.go("admin.posts.comments", {
        parentId: item.id,
        returnUrl: "/admin/communities/" + vm.userId + "/posts",
      });
    };

    vm.logs = function (item) {
      $state.go("admin.posts.logs", {
        parentId: item.id,
        returnUrl: "/admin/communities/" + vm.userId + "/posts",
      });
    };

    vm.blockedUsers = function (item) {
      $state.go("admin.posts.blocked_users", {
        parentId: item.id,
        returnUrl: "/admin/communities/" + vm.userId + "/posts",
      });
    };

    vm.commentsByBlockedUsers = function (item) {
      $state.go("admin.posts.blocked_user_comments", {
        parentId: item.id,
        returnUrl: "/admin/communities/" + vm.userId + "/posts",
      });
    };

    vm.delete = function (item) {
      swal(
        {
          title: "Are you Sure?",
          text: "",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (item["ts-p"] !== undefined || item["ts-p"] !== null) {
              PostsAdminService.update(item.id, { "ts-p": null }).then(
                function () {
                  PostsAdminService.remove(item.id).then(function () {
                    $state.reload();
                  });
                }
              );
            } else {
              PostsAdminService.remove(item.id).then(function () {
                $state.reload();
              });
            }
          }
        }
      );
    };

    vm.hide = function (item) {
      swal(
        {
          title: "Are you Sure?",
          text: "",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            PostsAdminService.hide(item.id).then(function () {
              $state.reload();
            });
          }
        }
      );
    };
  }
})();
